Currency.moneyFormats['EUR'] = {
  "money_format":"&euro;{{amount_no_decimals}}",
  "money_with_currency_format":"&euro;{{amount_no_decimals}} EUR"
};

Currency.moneyFormats['CAD'] = {
  "money_format":"${{amount_no_decimals}}",
  "money_with_currency_format":"${{amount_no_decimals}} CAD"
};

Currency.moneyFormats['GBP'] = {
  "money_format":"&pound;{{amount_no_decimals}}",
  "money_with_currency_format":"&pound;{{amount_no_decimals}} GBP"
};


Currency.moneyFormats['AUD'] = {
  "money_format":"${{amount_no_decimals}}",
  "money_with_currency_format":"${{amount_no_decimals}} AUD"
};

Currency.moneyFormats['AED'] = {
  "money_format":"Dhs. {{amount_no_decimals}}",
    "money_with_currency_format":"Dhs. {{amount_no_decimals}} AED"
};
